import type { KeyFactsV2Attributes } from '@/features/key-facts-v2/key-facts-v2-type';

import KeyFactsDesktop from '@/core/components/key-facts/key-facts-desktop';

export default function KeyFactsV2Desktop({ keyFacts, title }: KeyFactsV2Attributes) {
    if (keyFacts.length === 0) {
        return null;
    }
    return (
        <KeyFactsDesktop
            iconGap={'gap-10'}
            iconSize={18}
            keyFacts={keyFacts}
            title={title}
        />
    );
}
